import { type DefaultQueryError, httpClient } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
  DefaultOpsTechResponse,
  DefaultPagingParams,
  LocaleContent,
} from '../types';
import { RewardListingPromoType, RewardListingType } from './types';
import apiRoutes from '@/lib/api-routes';
import { assetPrefix } from '@/lib/constants';

export interface RewardCategory {
  id: number;
  name: LocaleContent;
  description?: LocaleContent;
  is_active?: boolean;
  is_delete?: boolean;
  index?: number;
  icon: string;
}

export type RewardCategoryWithLink = RewardCategory & { link: string };

export const top3Categories: RewardCategoryWithLink[] = [
  {
    id: -3,
    name: {
      vi: 'Tất cả ưu đãi',
      en: 'All',
    },
    icon: `${assetPrefix}/static/images/rewards/all-category.png`,
    link: `/rewards/search?type=${RewardListingType.ALL}`,
  },
  {
    id: -2,
    name: {
      vi: 'Flash Sale',
      en: 'Flash Sale',
    },
    icon: `${assetPrefix}/static/images/rewards/flash-sale-category.png`,
    link: `/rewards/search?type=${RewardListingType.FLASHSALE_ONLY}`,
  },
  {
    id: -1,
    name: {
      vi: 'Mã Giao Hàng',
      en: 'Promotion Code',
    },
    icon: `${assetPrefix}/static/images/rewards/ahamove-category.png`,
    link: `/rewards/search?promo_type=${RewardListingPromoType.AHAMOVE}`,
  },
];
export const getRewardCategoriesFn = async (
  params: Partial<DefaultPagingParams>
) => {
  const response = await httpClient.get<
    DefaultOpsTechResponse<RewardCategory[]>
  >(apiRoutes.rewards.category, {
    params,
  });
  const listCate: RewardCategoryWithLink[] = response.data
    ? response.data.data.map((item: RewardCategory) => ({
        ...item,
        link: `/rewards/search?category_id=${item.id}`,
      }))
    : ([] as RewardCategoryWithLink[]);
  return listCate.length > 0 ? top3Categories.concat(listCate) : top3Categories;
};

export const useGetRewardCategories = (
  params: Partial<DefaultPagingParams>,
  opts?: UseQueryOptions<RewardCategoryWithLink[], DefaultQueryError>
) =>
  useQuery<RewardCategoryWithLink[], DefaultQueryError>({
    queryKey: [apiRoutes.rewards.category, params],
    queryFn: () => getRewardCategoriesFn(params),
    ...opts,
  });
